export default __webpack_public_path__ + "static/media/figuremap73.27d213f2.png";